import React from "react";

function PurchaseHeader({
  formData,
  handleInputChange,
  suppliers,
  warehouses,
  errors,
}) {
  return (
    <div className="card shadow-sm border-0 mb-4">
      <div className="custom-modal-header text-white">
        <h5 className="mb-0">Purchase Information</h5>
      </div>

      <div className="card-body">
        <div className="row">

          <div className="col-md-4 mb-3">
            <label className="form-label">
              Supplier <span className="text-danger">*</span>
            </label>

            <select
              className={`form-select ${
                errors?.supplier_id ? "is-invalid" : ""
              }`}
              name="supplier_id"
              value={formData.supplier_id}
              onChange={handleInputChange}
            >
              <option value="">Select Supplier</option>

              {suppliers.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.supplier_name}
                </option>
              ))}
            </select>

            {errors?.supplier_id && (
              <div className="invalid-feedback">
                {errors.supplier_id}
              </div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">
              Warehouse <span className="text-danger">*</span>
            </label>

            <select
              className={`form-select ${
                errors?.warehouse_id ? "is-invalid" : ""
              }`}
              name="warehouse_id"
              value={formData.warehouse_id}
              onChange={handleInputChange}
            >
              <option value="">Select Warehouse</option>

              {warehouses.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.warehouse_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">Invoice No</label>

            <input
              type="text"
              className="form-control"
              name="invoice_no"
              value={formData.invoice_no}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">
              Purchase Date
            </label>

            <input
              type="date"
              className="form-control"
              name="purchase_date"
              value={formData.purchase_date}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">
              Payment Type
            </label>

            <select
              className="form-select"
              name="payment_type"
              value={formData.payment_type}
              onChange={handleInputChange}
            >
              <option value="cash">Cash</option>
              <option value="online">Online</option>
              <option value="credit">Credit</option>
            </select>
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">
              Paid Amount
            </label>

            <input
              type="number"
              className="form-control"
              name="paid_amount"
              value={formData.paid_amount}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-12">
            <label className="form-label">
              Remark
            </label>

            <textarea
              className="form-control"
              rows="3"
              name="remark"
              value={formData.remark}
              onChange={handleInputChange}
            />
          </div>

        </div>
      </div>
    </div>
  );
}

export default PurchaseHeader;